export class DogaNumber {
  private _dogaNumber: number

  constructor (dogaNumber: number) {
    if (dogaNumber < 1) {
      throw new TypeError('Doga number must be above zero')
    }
    this._dogaNumber = dogaNumber
  }

  dogaNumber (): number {
    return this._dogaNumber
  }
}
